var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{staticClass:"d-flex flex-row justify-space-between align-center",attrs:{"cols":"12","md":"11"}},[_c('h1',[_vm._v("Media Library")]),_c('AddMedia')],1)],1),_c('IndexMedia'),_c('EditMedia'),_c('DeleteMedia')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }